<template>
  <div>
    <div style="margin-top: -60px; height: 60px; padding-top: 7px;" v-if="globalBudgetAmount !== null" class="pl-2">
      <v-row>
        <v-progress-circular :rotate="-90" :size="75" :width="15" :value="globalUtilizationPercentage" :class="classByPercentage(globalUtilizationPercentage)">
          {{ globalUtilizationPercentage }}%
        </v-progress-circular>
        <v-row align-content="center">
          <v-col class="ml-3 pb-0" cols="12">
            <span style="font-weight: bold">{{ $t("booking.globalBudgetUtilization") }}: </span>
          </v-col>
          <v-col cols="12" class="ml-3 pb-0">
            <span style="font-weight: bold; font-size: large">
              <span :class="classByPercentage(globalUtilizationPercentage)" style="color: #44d3af; font-size: x-large">{{ globalBudgetUtilization }} PLN </span>
              / {{ globalBudgetAmount }} PLN</span
            >
          </v-col>
        </v-row>
      </v-row>
    </div>
    <div style="margin-top: 30px;">
      <h1 style="display: inline">{{ title }}</h1>
      <span class="mx-4" style="font-size: medium" v-if="typeBudgetAmount !== null">
        <span style="display: inline-block; position: relative; bottom: 7px;">
          <v-progress-circular :rotate="-90" :size="35" :width="8" :value="typeUtilizationPercentage" :class="classByPercentage(typeUtilizationPercentage)" />
        </span>
        <span class="pb-3">
          {{ typeUtilizationPercentage }}%
          <span :class="classByPercentage(typeUtilizationPercentage)" style="font-size: x-large;" class="ml-1">{{ typeBudgetUtilization }} PLN</span> /
          {{ typeBudgetAmount }} PLN
        </span>
        <span style="font-weight: lighter; font-size: small;">({{ $t("booking.typeBudgetUtilization") }})</span>
      </span>
    </div>

    <booking-menu />
  </div>
</template>

<script>
import BookingMenu from "./BookingMenu";
export default {
  name: "BookingMenuWithBudgetHeader",
  components: { BookingMenu },
  data: () => ({
    globalBudgetAmount: null,
    globalBudgetUtilization: null,
    typeBudgetAmount: null,
    typeBudgetUtilization: null
  }),
  props: {
    title: { required: true },
    budgetType: { required: false, default: null }
  },
  computed: {
    globalUtilizationPercentage() {
      if (this.globalBudgetAmount !== null) {
        return ((this.globalBudgetUtilization / this.globalBudgetAmount) * 100).toFixed(1);
      }
      return 0;
    },
    typeUtilizationPercentage() {
      if (this.typeBudgetAmount !== null) {
        return ((this.typeBudgetUtilization / this.typeBudgetAmount) * 100).toFixed(1);
      }
      return 0;
    }
  },
  methods: {
    classByPercentage(percentage) {
      if (percentage > 100) {
        return "error--text";
      }
      if (percentage > 90) {
        return "warning--text";
      }
      return "success--text";
    },
    downloadGlobalBudget() {
      this.axios.get("booking/budget/get-default-utilization").then(resp => {
        if (typeof resp.data.amount !== "undefined") {
          this.globalBudgetAmount = resp.data.amount;
          this.globalBudgetUtilization = resp.data.utilization;
        }
      });
    },
    downloadTypeBudget() {
      if (this.budgetType !== null) {
        this.axios.get("booking/budget/get-budget-utilization?type=" + this.budgetType).then(resp => {
          if (typeof resp.data.amount !== "undefined") {
            this.typeBudgetAmount = resp.data.amount;
            this.typeBudgetUtilization = resp.data.utilization;
          }
        });
      }
    }
  },
  created() {
    this.downloadGlobalBudget();
    this.downloadTypeBudget();
  }
};
</script>

<style scoped></style>
